import { PaymentMethods, Jurisdication } from "./visitor.model";

/*
*   @TODO - this will be replaced by an endpoint eventually
*/
export const paymentMethods: PaymentMethods[] = [
  {
    name: 'Visa',
    icon: "/assets/payment-providers/desktop/visa.svg",
    excludedJurisdictions: [],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
  {
    name: 'Trustly',
    icon: "/assets/payment-providers/desktop/trustly.svg",
    excludedJurisdictions: [],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
  {
    name: 'Paypal',
    icon: "/assets/payment-providers/desktop/paypal.svg",
    excludedJurisdictions: [],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
  {
    name: 'Sofort',
    icon: "/assets/payment-providers/desktop/sofort.svg",
    excludedJurisdictions: [Jurisdication.SGA, Jurisdication.MGA, Jurisdication.UKGC],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
  {
    name: 'Skrill',
    icon: "/assets/payment-providers/desktop/skrill.svg",
    excludedJurisdictions: [],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
  {
    name: 'Mastercard',
    icon: "/assets/payment-providers/desktop/mastercard.svg",
    excludedJurisdictions: [],
    includedOnlyLanguages: [],
    excludedOnlyLanguages: [],
  },
];
